<template>
	<div class="body">
		<div class="body-container">
			<div class="policy-container" v-for="(policy, index) in policyList" :key="index">
				<div class="policy-title-row">
					<div class="policy-title-text">{{ policy.name }}</div>
					<img class="title-icon" src="../assets/icons/riangle_red.png" />
				</div>
				<div class="paper-row" v-for="(paper, index) in policy.list" :key="index">
					<img class="point-pic" src="../assets/icons/circle_point.png" />
					<div class="paper-title" @click="clickRoute(paper)">{{ paper.name }}</div>
				</div>
				
				<div class="more-ctr">
					<div class="more-item" @click="clickMore(policy.id)">
						<label class="more-text">更多</label>
						<img src="../assets/icons/arrow_right.png" class="more-icon"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getIndex
	} from "@/api/policy"

	import {
		parse,handleProtocal,handleRouteProtocal
	} from "@/utils/protocal"
	

	export default {
		name: "Policy",
		data() {
			return {
				policyList: []
			}
		},
		created() {
			this.initPageData();
		},
		methods: {
			initPageData() {
				getIndex().then(res => {
					this.policyList = res.data.list;
				});
			},

			clickRoute(item) {				
				let data = parse(item.url)
				
				if(data['head'] == 'replace'){
					let url = "/" + data['path'];
					if (data['data'] != null && data['data'].length != 0) {
						url += "?" + data['data'];
					}
					console.log('url', url)
					// this.$router.replace(url);
					this.$router.push(url);
				}else{
					handleRouteProtocal(data)
				}	
			},
			
			clickMore(id){
				let path = '/policy_list?id=' + id;
				this.$router.push(path);
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "policy.scss";
</style>